var u = /* @__PURE__ */ ((r) => (r.small = "small", r.tiny = "tiny", r.sm = "sm", r.xs = "xs", r))(u || {}), e = /* @__PURE__ */ ((r) => (r.outlineSubtle = "outline-subtle", r.text = "text", r))(e || {}), s = /* @__PURE__ */ ((r) => (r.brand = "brand", r.primary = "primary", r))(s || {}), d = /* @__PURE__ */ ((r) => (r.rounded = "rounded", r.squared = "squared", r))(d || {});
export {
  s as EPaginationColor,
  d as EPaginationShape,
  u as EPaginationSize,
  e as EPaginationVariant
};
